import FTSkeleton from './FTSkeleton';
export default FTSkeleton;